
import { gql } from "apollo-boost"

export const createCommentsMeansOfVerification = gql`
  mutation CreateMeansOfVerificationComments(
    $meansOfVerification: ID!, 
    $data: CreateMonitoringCommentInput!
  ){
    CreateMeansOfVerificationComments(
      meansOfVerification: $meansOfVerification
      data: $data
    ){
      id
    }
  }
`